import React from "react";
import { Icon } from "semantic-ui-react";
import PropTypes from "prop-types";

const InlineError = ({ text }) => (
  <span className={"inline-error-text"}>
    <Icon
      name={"warning"}
      circular
      inverted
      color="yellow"
      size="tiny"
      className={"icon-align-middle"}
    />{" "}
    {text}
  </span>
);

InlineError.propTypes = {
  text: PropTypes.string.isRequired,
};

export default InlineError;



// WEBPACK FOOTER //
// ./src/components/messages/InlineError.js